var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2301_32548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.75 51C41.486 51 51 41.486 51 29.75C51 18.0139 41.486 8.5 29.75 8.5C18.0139 8.5 8.5 18.0139 8.5 29.75C8.5 41.486 18.0139 51 29.75 51Z",
    stroke: "#E8E8E8",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7764 44.7773L59.5 59.5009",
    stroke: "#E8E8E8",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8041 36.9494C36.4136 37.3399 35.7804 37.3399 35.3899 36.9494L29.918 31.4774L24.446 36.9494C24.0555 37.3399 23.4223 37.3399 23.0318 36.9494L22.3864 36.3039C21.9958 35.9134 21.9958 35.2802 22.3864 34.8897L27.8583 29.4178L22.3864 23.9458C21.9958 23.5553 21.9958 22.9221 22.3864 22.5316L23.0318 21.8861C23.4223 21.4956 24.0555 21.4956 24.446 21.8861L29.918 27.3581L35.3899 21.8861C35.7804 21.4956 36.4136 21.4956 36.8041 21.8861L37.4496 22.5316C37.8401 22.9221 37.8401 23.5553 37.4496 23.9458L31.9776 29.4178L37.4496 34.8897C37.8401 35.2802 37.8401 35.9134 37.4496 36.3039L36.8041 36.9494Z",
    fill: "#E8E8E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2301_32548"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.be2f3c77f37d6e05a13955b40f355ecf.svg";
export { ForwardRef as ReactComponent };